import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { useSite } from "../context/SiteContext";
import { Footer } from "./Footer";
import { MobileActionBar } from "./MobileActionBar";
import { SiteMeta } from "./SiteMeta";
import { WelcomeIntro } from "./WelcomeIntro";
export function SiteLayout() {
  const {
    t
  } = useSite();
  return <div className="mexican-wallpaper min-h-screen w-full text-charcoal" data-id="element-368" data-mp="3dw2q3xdls0t1">
      <SiteMeta data-id="element-369" data-mp="3dvt049sk5tnc" />
      <WelcomeIntro data-id="element-370" data-mp="3du8c730r18yg" />
      <a href="#main-content" className="fixed left-3 top-3 z-[100] -translate-y-20 rounded bg-white px-4 py-3 font-bold text-cocoa shadow focus:translate-y-0" data-id="element-371" data-mp="3iunqbwsuukhh">{t("Skip to content", "Saltar al contenido")}</a>
      <Header data-id="element-372" data-mp="3sl8ltbd8f8w6" />
      <main id="main-content" data-id="element-373" data-mp="3sjxj7eviw76n"><Outlet data-id="element-374" data-mp="3sk79z4oe6ide" /></main>
      <Footer data-id="element-375" data-mp="3smthx5f72zw5" />
      <MobileActionBar data-id="element-376" data-mp="1enx3yangd2b" />
    </div>;
}